import {Component, contentChildren, effect, input, linkedSignal} from "@angular/core";
import {ButtonSegmentComponent} from "@common/ui/segmented-button/button-segment/button-segment.component";

@Component({
	selector: "sim-segmented-button",
	imports: [],
	templateUrl: "./segmented-button.component.html",
	styleUrl: "./segmented-button.component.scss",
})
export class SegmentedButtonComponent {
	public readonly activeSegment = input(0);

	readonly #activeSegment = linkedSignal(() => this.activeSegment());

	protected readonly buttonSegments = contentChildren(ButtonSegmentComponent);

	public setActiveSegment(index: number): void {
		if (index < 0 || index >= this.buttonSegments().length) {
			throw new Error("Index out of bounds");
		}
		this.#activeSegment.set(index);
	}

	readonly #effectSetup = effect(() => {
		this.buttonSegments().forEach((segment, index) => {
			segment.registerClickListener(index, this.#activeSegment);
		});
	});
}
